// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1GL1C","range":"MonthRangeSwitch_range__QGn8q","disabled":"MonthRangeSwitch_disabled__1BC0X"};